var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-main-content",
      staticStyle: {
        "flex-grow": "1",
        display: "flex",
        "flex-direction": "column"
      },
      attrs: { id: "order-template-config" }
    },
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-tab",
          staticStyle: {
            "flex-grow": "1",
            display: "flex",
            "flex-direction": "column"
          }
        },
        [
          _c(
            "el-tabs",
            {
              staticStyle: { width: "100%" },
              attrs: { type: "card" },
              on: { "tab-click": _vm.handClick },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_OceanExport"),
                    name: "SeaExportTemplate"
                  }
                },
                [
                  _c("order-template", {
                    ref: "orderTemplate",
                    attrs: { lob: "SE" }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_OceanImport"),
                    name: "SeaImportTemplate"
                  }
                },
                [
                  _c("order-template", {
                    ref: "orderTemplate",
                    attrs: { lob: "SI" }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_AirExport"),
                    name: "AirExportTemplate"
                  }
                },
                [
                  _c("order-template", {
                    ref: "orderTemplate",
                    attrs: { lob: "AE" }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_AirImport"),
                    name: "AirImportTemplate"
                  }
                },
                [
                  _c("order-template", {
                    ref: "orderTemplate",
                    attrs: { lob: "AI" }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_RailwayBusiness"),
                    name: "RailwayBussiness"
                  }
                },
                [
                  _c("order-template", {
                    ref: "orderTemplate",
                    attrs: { lob: "RB" }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_FbaOrder"),
                    name: "FbaImportTemplate"
                  }
                },
                [
                  _c("order-template", {
                    ref: "orderTemplate",
                    attrs: { lob: "FBA" }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_FbaSea"),
                    name: "FbaSeaImportTemplate"
                  }
                },
                [
                  _c("order-template", {
                    ref: "orderTemplate",
                    attrs: { lob: "FBA_SE" }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_FbaAir"),
                    name: "FbaAirExportTemplate"
                  }
                },
                [
                  _c("order-template", {
                    ref: "orderTemplate",
                    attrs: { lob: "FBA_AE" }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_FbaRailway"),
                    name: "FbaRailwayBussiness"
                  }
                },
                [
                  _c("order-template", {
                    ref: "orderTemplate",
                    attrs: { lob: "FBA_RE" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }